export const ENDPOINT_V1 = 'taxlab';
export const ENDPOINT_V2 = 'thynkbookV2';
